import { DateTime } from "luxon";

/**
 * e.g. Thursday 1 January 1970
 * @param {number} timestamp
 */
export const formatFullDate = (timestamp) => {
  return DateTime.fromMillis(timestamp).toFormat("DDDD");
};
